import React from 'react';
import PropTypes from 'prop-types';
import { translateResourceString } from '../../../util/translationUtility';
import ProductTileAddToListLink from './ProductTileAddToListLink';
import { generateLoginPageWithReturnUrlLink } from '../../../util/loginPageLinkUtility';

class ProductTileVariation extends React.PureComponent {
    constructor(props) {
        super(props);
        this.StepQuantity = props.variation.EnforceCaseCount ? props.variation.CaseCount : 1;
        this.MinimumOrderQuantity = Math.max(props.variation.MinimumOrderQuantity, this.StepQuantity);
        this.state = {
            quantity: !!props.variation.quantity ? Math.max(props.variation.quantity, this.MinimumOrderQuantity) : this.MinimumOrderQuantity,
            addToCartLoginLink: this.props.loginPageUrl
        };
    }

    componentDidMount() {
        // This is a slight hack to re-render the login link client-side after server-side rendering
        if (!this.props.isUserLoggedIn) {
            const upToDateLoginLink = generateLoginPageWithReturnUrlLink(this.props.loginPageUrl, this.props.variation.MasterItemNumber, false, true);
            if (this.state.addToCartLoginLink !== upToDateLoginLink) {
                this.setState({ addToCartLoginLink: upToDateLoginLink });
            }
        }
    }

    validQuantity = (quantityInput) => {
        const parsed = parseInt(quantityInput);
        return !isNaN(parsed) && parsed >= this.MinimumOrderQuantity && parsed % this.StepQuantity == 0;
    }

    handleQuantityChange = (event) => {
        this.setState({ quantity: parseInt(event.target.value) });
    }

    handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            if (window.innerWidth < 992) {
                event.target.blur();
            } else {
                this.onAddToCart();
            }
        }
    }

    onAddToCart = () => {
        this.props.onAddToCart(this.props.variation, this.state.quantity, this.onAddToCartSuccess);
    }

    onAddToCartSuccess = () => {
        this.setState({
            quantity: this.MinimumOrderQuantity
        });
    }

    render() {
        const {
            variation,
            hidePrices,
            hideInventory,
            onProductClick,
            wishlistData,
            toggleAddToListModal,
            addToCartBreakpoint,
            loginPageUrl,
            isUserLoggedIn,
            isOrderRequestOnlyMarket
        } = this.props;

        const { quantity } = this.state;
        const validInput = this.validQuantity(quantity);
        const qtyClassSelector = "qty-option-" + variation.Code;
        const qtyClassName = "featured-product-with-variations__count " + qtyClassSelector;
        const qtyBoxId = "quanitityBox-"+ variation.SKU;
        const qtyBoxVariationId = qtyBoxId +"_"+ variation.Code;

        return (
            <>
                <tr className="featured-product-with-variations__variation-row">
                    <td>
                        <a className="featured-product-with-variations__variation-name" href={variation.Link} onClick={(e) => onProductClick(e, variation)} dangerouslySetInnerHTML={{ __html: variation.Name }} />
                    </td>
                    {!!variation.CatalogNumber
                        ? <td className="pe-none">{variation.SKU} | {variation.CatalogNumber}</td>
                        : <td className="pe-none">{variation.SKU}</td>
                    }
                    {!hidePrices &&
                        <td>
                            <div>
                                {!!variation.PriceViewModel && !variation.HidePrice &&
                                    <React.Fragment>
                                        {variation.PriceViewModel.IsSalePrice ? (
                                            <div>
                                                <p className="featured-product-with-variations__price">{variation.PriceViewModel.SalePrice}</p>
                                                <p className="featured-product-with-variations__old-price">{variation.PriceViewModel.RegularPrice}</p>
                                            </div>
                                        ) : (
                                                <div>
                                                    <p className="featured-product-with-variations__price">{variation.PriceViewModel.RegularPrice}</p>
                                                </div>
                                            )}
                                    </React.Fragment>
                                }
                            </div>
                        </td>
                    }
                    {!hideInventory &&
                        <td>
                            {variation.ShowInventoryAvailable &&
                                (variation.IsInStock
                                    ? <div className="stock">{translateResourceString("/Product/Index/InStock")}</div>
                                    : <>
                                        <div className="stock out fw-400">{translateResourceString("/Product/Index/OutOfStock")}</div>
                                    </>
                                )
                            }
                        </td>
                    }
                    <td className={"d-none d-" + addToCartBreakpoint + "-table-cell pr-" + addToCartBreakpoint + "-0 text-right"}>
                        <div className="featured-product-with-variations__actions">
                            {!variation.CanAddToCart
                                ? <div className="featured-product-with-variations__view">
                                    <a className="btn btn-link" href={variation.Link} onClick={(e) => onProductClick(e, variation)}>{translateResourceString("/Search/ViewButton")}</a>
                                </div>
                                : <>
                                    <div className="featured-product-with-variations__min-qty">
                                        {variation.MinimumOrderQuantity > 0 &&
                                            <div className="mr-3">
                                                <span>{translateResourceString("/ShoppingCart/Index/Item/MinQtyMessage").replace("{0}", variation.MinimumOrderQuantity)}</span>
                                            </div>
                                        }
                                        {variation.EnforceCaseCount &&
                                            <div className="mr-3">
                                                <span>{translateResourceString("/ShoppingCart/Index/Item/CaseQtyMessage").replace("{0}", variation.CaseCount)}</span>
                                            </div>
                                        }
                                    </div>
                                    <label className='visually-hidden' htmlFor={qtyBoxId}>{translateResourceString("/Product/Tile/QuantityLabel")}</label>
                                    <input className={qtyClassName} id={qtyBoxId} value={this.state.quantity} type="number" min={this.MinimumOrderQuantity} step={this.StepQuantity} onChange={this.handleQuantityChange} onKeyPress={this.handleKeyPress} aria-label={translateResourceString("/Product/AddToCart/QuantityLabel")} />
                                    {isUserLoggedIn || !isOrderRequestOnlyMarket
                                        ? <button className="btn btn-xs btn-neogen-green js-btn-add-to-cart-confirm" disabled={!validInput} onClick={this.onAddToCart}>{translateResourceString("/Search/AddToCartButton")}</button>
                                        : <a className="btn btn-xs btn-neogen-green" disabled={!validInput} href={this.state.addToCartLoginLink}>{translateResourceString("/Search/AddToCartButton")}</a>
                                    }
                                </>
                            }             
                            <div className="list-button">
                                <ProductTileAddToListLink
                                    linkClass={variation.addToListLinkClass}
                                    isUserLoggedIn={isUserLoggedIn}
                                    toggleModal={toggleAddToListModal}
                                    variation={variation}
                                    loginPageUrl={loginPageUrl}
                                />
                            </div>
                        </div>
                    </td>
                </tr>
                <tr className={"d-" + addToCartBreakpoint + "-none featured-product-with-variations__variation-actions-row"}>
                    <td className={"d-" + addToCartBreakpoint + "-none pt-0"} colSpan="4">
                        <div className="featured-product-with-variations__actions justify-content-start">
                            {!variation.CanAddToCart ?
                                <a className="btn btn-link" href={variation.Link} onClick={(e) => onProductClick(e, variation)}>{translateResourceString("/Search/ViewButton")}</a>
                                : <>
                                    <div className="featured-product-with-variations__min-qty text-right">
                                        {variation.MinimumOrderQuantity > 0 &&
                                            <div className="mr-3">
                                                <span>{translateResourceString("/ShoppingCart/Index/Item/MinQtyMessage").replace("{0}", variation.MinimumOrderQuantity)}</span>
                                            </div>
                                        }
                                        {variation.EnforceCaseCount &&
                                            <div className="mr-3">
                                                <span>{translateResourceString("/ShoppingCart/Index/Item/CaseQtyMessage").replace("{0}", variation.CaseCount)}</span>
                                            </div>
                                        }
                                    </div>
                                    <label className='visually-hidden' htmlFor={qtyBoxVariationId}>{translateResourceString("/Product/Tile/QuantityLabel")}</label>
                                    <input className="featured-product-with-variations__count qty-option" id={qtyBoxVariationId} value={this.state.quantity} type="number" min={this.MinimumOrderQuantity} step={this.StepQuantity} onChange={this.handleQuantityChange} onKeyPress={this.handleKeyPress} aria-label={translateResourceString("/Product/AddToCart/QuantityLabel")} />
                                    {isUserLoggedIn || !isOrderRequestOnlyMarket
                                        ? <button className="btn btn-xs btn-neogen-green js-btn-add-to-cart-confirm" disabled={!validInput} onClick={this.onAddToCart}>{translateResourceString("/Search/AddToCartButton")}</button>
                                        : <a className="btn btn-xs btn-neogen-green" disabled={!validInput} href={this.state.addToCartLoginLink}>{translateResourceString("/Search/AddToCartButton")}</a>
                                    }
                                </>
                            }           
                            <div className="list-button">
                                <ProductTileAddToListLink
                                    linkClass={variation.addToListLinkClass}
                                    isUserLoggedIn={isUserLoggedIn}
                                    toggleModal={toggleAddToListModal}
                                    variation={variation}
                                    loginPageUrl={loginPageUrl}
                                />
                            </div>
                        </div>
                    </td>
                </tr>
            </>
        );
    }
}

ProductTileVariation.propTypes = {
    variation: PropTypes.shape({
        Link: PropTypes.string,
        Name: PropTypes.string,
        GtmName: PropTypes.string,
        SKU: PropTypes.string,
        Code: PropTypes.string,
        MasterItemNumber: PropTypes.string,
        PriceViewModel: PropTypes.shape({
            RegularPrice: PropTypes.string,
            SalePrice: PropTypes.string,
            IsSalePrice: PropTypes.bool
        }),
        CanAddToCart: PropTypes.bool,
        HidePrice: PropTypes.bool,
        ShowInventoryAvailable: PropTypes.bool,
        IsInStock: PropTypes.bool,
        GoogleTagManagerProductFieldObject: PropTypes.object,
        MinimumOrderQuantity: PropTypes.number,
        CaseCount: PropTypes.number,
        EnforceCaseCount: PropTypes.bool,
    }).isRequired,
    hidePrices: PropTypes.bool,
    hideInventory: PropTypes.bool,
    onProductClick: PropTypes.func.isRequired,
    onAddToCart: PropTypes.func.isRequired,
    addToCartBreakpoint: PropTypes.string,
    loginPageUrl: PropTypes.string,
    isUserLoggedIn: PropTypes.bool,
    isOrderRequestOnlyMarket: PropTypes.bool
    //handleKeyPress: PropTypes.func.isRequired
};

export default ProductTileVariation;